import type { HTTPMethod } from './http-method';

/**
 * A request that never produced a readable HTTP response — DNS, TLS, offline, or a
 * dropped connection. It is retryable, so it is reported by the retry layer once the
 * retries are exhausted, never per attempt.
 */
export class NetworkError extends Error {
    public override readonly name = 'NetworkError';

    public readonly method: HTTPMethod;

    public readonly url: string;

    public constructor(method: HTTPMethod, url: string, cause: unknown) {
        const causeMessage = cause instanceof Error ? `: ${cause.message}` : '';

        super(`Could not fetch ${method} ${url}${causeMessage}`, { cause });

        this.method = method;
        this.url = url;
    }
}
